import {
	CreateDrawerFormProps,
	DateField,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	TextField,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IVacationEntitlementFormState } from "~shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: IVacationEntitlementFormState) => {
		const errors: { [K in keyof IVacationEntitlementFormState]?: any } = {};

		if (!values.entryDate) {
			errors.entryDate = t("Field is required");
		}
		if (!values.hoursPerDay) {
			errors.hoursPerDay = t("Field is required");
		}
		if (!values.yearlyVacationDays) {
			errors.yearlyVacationDays = t("Field is required");
		}

		return errors;
	};
};

const VacationEntitlementUpdateDrawerContentProps: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<DateField name="entryDate" label={t("Entry date")} required />
			<DateField name="leaveDate" label={t("Leave date")} />
			<TextField name="yearlyVacationDays" label={t("Yearly vacation days")} required type="number" />
			<TextField name="hoursPerDay" label={t("Hours per day")} type="number" required />
		</FormDrawerContent>
	);
};

interface Props extends CreateDrawerFormProps<IVacationEntitlementFormState> {
	initialValues: IVacationEntitlementFormState;
}

export const VacationEntitlementUpdateDrawer: FC<Props> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormDrawer
			{...drawerProps}
			title={t("Edit vacation entitlement")}
			validate={validate}
			renderForm={(props) => <VacationEntitlementUpdateDrawerContentProps {...props} />}
		/>
	);
};
